import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";
import { logger } from '@/services/LoggingService';

interface DataPersistenceToggleProps {
  initialValue: boolean;
  onChange: (persist: boolean) => void;
  disabled?: boolean;
  isLoading?: boolean;
}

export function DataPersistenceToggle({
  initialValue,
  onChange,
  disabled = false,
  isLoading = false,
}: DataPersistenceToggleProps) {
  logger.info('DataPersistenceToggle', '🔄 PERSISTENCE TOGGLE: Render', {
    initialValue,
    disabled,
    isLoading,
    hasOnChange: !!onChange,
    timestamp: new Date().toISOString()
  });

  const handleChange = (checked: boolean) => {
    logger.info('DataPersistenceToggle', '🔄 PERSISTENCE TOGGLE: Value changed', {
      previousValue: initialValue,
      newValue: checked,
      timestamp: new Date().toISOString()
    });
    onChange(checked);
  };

  return (
    <div className="flex items-center gap-3 justify-end">
      <label 
        htmlFor="persist-toggle" 
        className={`text-sm ${disabled ? 'text-gray-400' : 'text-muted-foreground'} select-none cursor-pointer`}
      >
        Store this data
      </label>
      <Switch
        checked={initialValue}
        onCheckedChange={handleChange}
        disabled={disabled || isLoading}
        className={cn(
          "data-[state=checked]:bg-green-600", // Keep the green color for ON state
          disabled && "opacity-50 cursor-not-allowed",
          isLoading && "cursor-wait"
        )}
        id="persist-toggle"
      />
    </div>
  );
}
